<template>
  <div class="cs-appointment-step3">
    <div class="stepContent">
      <el-row class="cs-appointment-step3-info">
        <el-col :span="24">
          <el-row>
            <el-col>
              <span class="cs-appointment-step3-label">日期:</span>&nbsp;&nbsp;
              <span>{{ dataIn.appDate }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <span class="cs-appointment-step3-label">预约时间:</span>&nbsp;&nbsp;
              <span>{{ dataIn.startTime }} - {{ dataIn.endTime }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <span class="cs-appointment-step3-label">校区:</span>&nbsp;&nbsp;
              <span>{{ dataIn.campusName }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <span class="cs-appointment-step3-label">电脑:</span>&nbsp;&nbsp;
              <span>{{ dataIn.computerName }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <span class="cs-appointment-step3-label">预约课程:</span>&nbsp;&nbsp;
              <span>{{ dataIn.courseName }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <span class="cs-appointment-step3-label">课程周:</span>&nbsp;&nbsp;
              <span>{{ dataIn.weekText }}</span>
            </el-col>
          </el-row>
          <div v-if="!dataIn.isFreeForAll">
            <el-row v-if="dataIn.isFree">
              <el-col>
                <span class="cs-appointment-step3-label">价格:</span>&nbsp;&nbsp;
                <span>免费回看(押金: C{{ dataIn.price | toCurrency }})，为防止同学浪费校区电脑资源，当按照预约时间准时观看视频后押金会自动退还。</span>
              </el-col>
            </el-row>
            <el-row v-else>
              <el-col>
                <span class="cs-appointment-step3-label">价格:</span>&nbsp;&nbsp;
                <span>C{{ dataIn.price | toCurrency }}</span>
              </el-col>
            </el-row>
          </div>
          <el-row v-if="dataIn.needPay || payments.length > 0">
            <el-col>
              <span class="cs-appointment-step3-label">已支付:</span>&nbsp;&nbsp;
              <span>C{{ payment | toCurrency }}</span>
            </el-col>
          </el-row>
          <el-row class="cs-redLabel" v-if="dataIn.needPay || payments.length > 0">
            <el-col>
              <span class="cs-appointment-step3-label">待付款:</span>&nbsp;&nbsp;
              <span>C{{ debt | toCurrency }}</span>
            </el-col>
          </el-row>
          <div v-if="!dataIn.isOwnDevice">
            <el-row>
              <el-col>
                <span class="cs-appointment-step3-label"></span>&nbsp;&nbsp;
                <span class="cs-redLabel">每个课节可观看总时长为每一节直播课程时长的倍数({{dataIn.studentVideoDurationText}})</span>
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col>
                <span class="cs-appointment-step3-label"></span>&nbsp;&nbsp;
                <span class="cs-redLabel">由于校区资源有限，提交预约后，视频观看时长将减掉该次预约时长</span>
              </el-col>
            </el-row> -->
            <el-row>
              <el-col>
                <span class="cs-appointment-step3-label">预约时长:</span>&nbsp;&nbsp;
                <span>{{ minutesText }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <span class="cs-appointment-step3-label">提交后剩余观看时长:</span>&nbsp;&nbsp;
                <span>{{ remainingMinutesText }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <span class="cs-appointment-step3-label"></span>&nbsp;&nbsp;
                <span>请同学们确认预约课节和时间</span>
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col>
                <span class="cs-appointment-step3-label"></span>&nbsp;&nbsp;
                <span>如有特殊情况，请联系前台客服取消预约</span>
              </el-col>
            </el-row> -->
            <el-row>
              <el-col>
                <span class="cs-appointment-step3-label cs-redLabel">注意:</span>&nbsp;&nbsp;
                <span class="cs-redLabel">您可以在{{cancelTimeText}}之前取消预约，将不会扣除观看视频的时长</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <span class="cs-appointment-step3-label"></span>&nbsp;&nbsp;
                <span class="cs-redLabel">如果迟到或者未能按照指定时间到校区观看，您的视频观看时长将扣除{{dataIn.minutes}}分钟</span>
              </el-col>
            </el-row>
          </div>
          <el-row v-else>
            <el-col>
              <span class="cs-appointment-step3-label"></span>&nbsp;&nbsp;
              <span class="cs-redLabel">每个课节可观看总时长为每一节直播课程时长的倍数({{dataIn.studentVideoDurationText}})，请同学确认预约课节是否正确。</span>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="18">
          <hr>
        </el-col>
      </el-row>
      <el-row v-if="dataIn.needPay || payments.length > 0">
        <el-col>
          <paymentListView :dataList="payments"
            :options="{ enableEdit: false, enableRemove: dataIn.paymentEnable, paymentTypes: paymentTypes, displayType: 'normal' }"
            @item-remove="onPaymentRemove"></paymentListView>
        </el-col>
      </el-row>
      <el-row>
        <el-col>&nbsp;</el-col>
      </el-row>
      <el-row v-if="dataIn.needPay || payments.length > 0">
        <el-col>
          <el-button v-if="dataIn.paymentEnable && debt > 0" size="medium" :disabled="submitBtnDisable" type="primary"
            :loading="isLoadMemberInfo" @click="showAddPaymentEditor">添加支付</el-button>
        </el-col>
      </el-row>
      <el-dialog title="添加支付" :center="true" :close-on-click-modal="false" width="600px"
        :visible.sync="paymentEditorVisible" top="3vh">
        <avappPayEditor @save="onSavePayment" :dataIn="paymentEditorData"></avappPayEditor>
      </el-dialog>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cs-appointment-step3 {
  .cs-appointment-step3-info {
    .cs-appointment-step3-label {
      width: 140px;
      display: inline-block;
    }

    span {
      line-height: 1.5rem;
    }

  }
}
</style>

<script>
import avappPayEditor from "./avappPayEditor";
import { getStudentMemberInfo } from "../../service/student.service";
import paymentListView from "../common/paymentListView";
import { getBonusPointMechanismByType } from "../../service/bonusPoint.service";
import { guid, formatMinutes } from "../../config/mUtils";

export default {
  props: {
    isCompleted: Boolean,
    dataIn: {
      paymentEnable: Boolean,
      videoAppointmentId: Number,
      studentId: Number,
      appDate: String,
      startTime: String,
      endTime: String,
      campusName: String,
      computerName: String,
      courseName: String,
      weekText: String,
      price: Number,
      isFree: Boolean,
      needPay: Boolean,
      isOwnDevice: Boolean,
      minutes: Number,
      availableMinutes: Number,
      model: {
        balanceCost: Number,
        bonusPointCost: Number,
        bonusPointPrice: Number
      },
      studentVideoDurationText: String
    }
  },
  data() {
    return {
      submitBtnClass: "primary",
      submitBtnDisable: false,
      paymentEditorVisible: false,
      isLoadMemberInfo: false,
      studentInfo: {},
      paymentModel: {
        balanceCost: 0,
        bonusPointCost: 0,
        bonusPointPrice: 0
      },
      priceSettings: {
        bonusPointToMoney_Money: 0,
        bonusPointToMoney_BonusPoint: 0
      },
      paymentTypes: [
        {
          Id: 1,
          Name: "credits",
          Description: "会员积分",
          HasServiceCharge: false
        },
        {
          Id: 2,
          Name: "balance",
          Description: "账户余额",
          HasServiceCharge: false
        }
      ],
      payments: [],
      paymentEditorData: {},
      minutesText: "",
      remainingMinutesText: "",
      cancelTimeText:""
    };
  },
  components: {
    avappPayEditor,
    paymentListView
  },
  created() {
    getBonusPointMechanismByType(2).then(result => {
      if (result && result.success) {
        this.priceSettings.bonusPointToMoney_Money = result.data.Money;
        this.priceSettings.bonusPointToMoney_BonusPoint =
          result.data.BonusPoint;
      }
    });

    this.init();
  },
  methods: {
    init() {
      if (!!this.dataIn && !!this.dataIn.model) {
        this.minutesText = formatMinutes(this.dataIn.minutes, true);
        let remainingMinutes = this.dataIn.availableMinutes - this.dataIn.minutes;
        if (remainingMinutes < 0) {
          remainingMinutes = 0;
        }
        this.remainingMinutesText = formatMinutes(remainingMinutes, true);
        this.paymentModel = this.dataIn.model;
        this.payments = [];
        if (this.paymentModel.bonusPointPrice > 0) {
          let payment = this.getPaymentItem(
            1,
            this.paymentModel.bonusPointPrice
          );
          this.payments.push(payment);
        }
        if (this.paymentModel.balanceCost > 0) {
          let payment = this.getPaymentItem(2, this.paymentModel.balanceCost);
          this.payments.push(payment);
        }
        this.getStudentInfo();
        this.cancelTimeText = this.dataIn.appDate + " " + this.dataIn.startTime;
      } else {
        this.paymentModel = {
          balanceCost: 0,
          bonusPointCost: 0,
          bonusPointPrice: 0 //金额
        };
      }
    },
    onSavePayment(data) {
      this.payments = data;
      this.loadPaymentModelData();
      this.paymentEditorVisible = false;

    },
    onPaymentRemove(index, item) {
      this.payments.splice(index, 1);
      this.loadPaymentModelData();
    },
    getPaymentItem(paymentType, amount) {
      let title = "";
      switch (paymentType) {
        case 1: {
          title = "积分支付";
          break;
        }
        case 2: {
          title = "余额支付";
          break;
        }
      }
      let payment = {
        Id: guid(),
        AccountId: 0,
        PaymentTypeId: paymentType,
        Amount: amount,
        Tax: 0,
        ServiceCharge: 0,
        Title: title,
        Enable: true
      };
      return payment;
    },
    getStudentInfo() {
      this.isLoadMemberInfo = true;
      getStudentMemberInfo().then(result => {
        if (!!result && result.success) {
          this.studentInfo = result.data;
        }
        this.isLoadMemberInfo = false;
      });
    },
    getPaymentEditorData() {
      this.paymentEditorData = {
        price: this.dataIn.price,
        memberInfo: this.studentInfo,
        priceSettings: this.priceSettings
      };
    },
    showAddPaymentEditor() {
      this.getPaymentEditorData();
      this.paymentEditorVisible = true;
    },
    loadPaymentModelData() {
      this.paymentModel = {
        balanceCost: 0,
        bonusPointCost: 0,
        bonusPointPrice: 0 //金额
      };

      this.payments.forEach(element => {
        if (element.PaymentTypeId == 1) {
          //积分
          this.paymentModel.bonusPointPrice = element.Amount;
          this.paymentModel.bonusPointCost =
            (element.Amount * this.priceSettings.bonusPointToMoney_BonusPoint) /
            this.priceSettings.bonusPointToMoney_Money;
        } else if (element.PaymentTypeId == 2) {
          //余额
          this.paymentModel.balanceCost = element.Amount;
        }
      });
    },
    getData() {
      return this.paymentModel;
    },
    valid() {
      if (!!this.dataIn) {
        if (this.dataIn.needPay && this.debt > 0) {
          this.$message.warning("请先完成付款");
          return false;
        }
        return true;
      }
      return false;
    }
  },
  computed: {
    payment: function () {
      return this.paymentModel.balanceCost + this.paymentModel.bonusPointPrice;
    },
    debt: function () {
      return this.dataIn.price - this.payment;
    }
  },
  watch: {
    dataIn: function () {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addVideoAppointment/avappWorkflowStep3.vue